import SegnalazioneStructure from "../../models/objs/SegnalazioneStructure";
import StorStructureLabels from "../../models/objs/SegnalazioneStructureLabels";
import ArricchimentoStructure from "../../models/objs/ArricchimentoStructure";
import FiltroStructure from "../../models/objs/FiltroStructure";
import LineOfInquiryStructure from "../../models/objs/LineOfInquiryStructure";
import FunzionarioStructure from "../../models/objs/FunzionarioStructure";
import FunzionarioLeaderStructure from "../../models/objs/FunzionarioLeaderStructure";
import FiltroExternalStructure from "../../models/objs/FiltroStructureExternal";
import NotaMABStructure from "../../models/objs/NotaMABStructure";
import LineOfInquiryFunzionariStructure from "../../models/objs/LineOfInquiryFunzionariStructure";
import OsservatoreStructure from "../../models/objs/OsservatoreStructure";

const SegnalazioniStructureService = {

    getStructure: function(segnalazioneType : string, userRole : string) {
        return SegnalazioneStructure.getStructure(segnalazioneType, userRole)
    },

    getLabelsOfStructure: function() {
        return StorStructureLabels
    },

    getArricchimentoStructure: function() {
        return ArricchimentoStructure.getStructure()
    },

    getFunzionarioStructure: function() {
        return FunzionarioStructure.getStructure()
    },

    getOsservatoreStructure: function() {
        return OsservatoreStructure.getStructure()
    },

    getFunzionarioLeaderStructure: function() {
        return FunzionarioLeaderStructure.getStructure()
    },

    getNotaMabStructure: function() {
        return NotaMABStructure.getStructure()
    },

    getLoiStructure: function() {
        return LineOfInquiryStructure.getStructure()
    },

    getFunzionariLoiStructure: function() {
        return LineOfInquiryFunzionariStructure.getStructure()
    },

    getFiltroStructure: function() {
        return FiltroStructure.getStructure()
    },

    getFiltroExternalStructure: function() {
        return FiltroExternalStructure.getStructure()
    },
}

export default SegnalazioniStructureService